<template>
  <!-- Campo de texto -->
  <v-text-field
    v-if="field.type === 'string'"
    v-model="localValue"
    :label="field.label"
    :hint="field.description"
    :rules="validationRules"
    :disabled="field.disabled"
    :required="field.required"
    persistent-hint
    @input="handleInput"
    :loading="loading"
  ></v-text-field>

  <!-- Campo numérico -->
  <v-text-field
    v-else-if="field.type === 'number'"
    v-model.number="localValue"
    :label="field.label"
    :hint="field.description"
    :rules="validationRules"
    :disabled="field.disabled"
    :required="field.required"
    type="number"
    persistent-hint
    @input="handleInput"
    :loading="loading"
  ></v-text-field>

  <!-- Campo booleano -->
  <v-switch
    v-else-if="field.type === 'boolean'"
    v-model="localValue"
    :label="field.label"
    :hint="field.description"
    :disabled="field.disabled"
    :required="field.required"
    color="primary"
    persistent-hint
    @change="handleInput"
    :loading="loading"
    class="ma-0"
  ></v-switch>

  <!-- Campo de selección múltiple -->
  <v-select
    v-else-if="field.type === 'array'"
    v-model="localValue"
    :items="field.options"
    :label="field.label"
    :hint="field.description"
    :rules="validationRules"
    :disabled="field.disabled"
    :required="field.required"
    multiple
    chips
    small-chips
    persistent-hint
    @change="handleInput"
    :loading="loading"
  ></v-select>
</template>

<script>
export default {
  name: "CustomFieldRenderer",
  props: {
    field: {
      type: Object,
      required: true,
      validator: field => {
        return ["string", "number", "boolean", "array"].includes(field.type);
      }
    },
    value: {
      type: [String, Number, Boolean, Array],
      default: null
    },
    loading: Boolean
  },
  data() {
    return {
      localValue: this.value
    };
  },
  computed: {
    validationRules() {
      const rules = [];

      if (this.field.required) {
        rules.push(v => !!v || "Este campo es requerido");
      }

      if (this.field.type === "number") {
        rules.push(v => !isNaN(v) || "Debe ser un número válido");
      }

      if (this.field.type === "array" && this.field.required) {
        rules.push(
          v => (v && v.length > 0) || "Debe seleccionar al menos una opción"
        );
      }

      return rules;
    }
  },
  watch: {
    value(newValue) {
      this.localValue = newValue;
    }
  },
  methods: {
    handleInput() {
      this.$emit("input", this.localValue);
      this.$emit("change", this.localValue);
    }
  }
};
</script>
